import * as Yup from 'yup';
import { getTrimmedValue } from '../../../../../utils/utilities';
import {
  getNameValidationSchema,
  getUANValidationSchema
} from '../../../../../utils/ValidationSchema';

export default Yup.object().shape({
  full_name: getNameValidationSchema({ message: 'name', isRequired: true }),
  employee_id: Yup.string()
    .transform((c) => getTrimmedValue(c, true))
    // .matches(/^[^-\s]+$/, 'Please enter a valid Employee ID')
    .when('employee_id_exists', {
      is: true,
      then: Yup.string('Employee ID already exists')
    }),
  uan_number: getUANValidationSchema({}),
  gender: Yup
    .string()
    .when("is_sex_optional", {
      is: false,
      then: Yup.string().required("Sex is required")
    })
});
